/**
 * VoiceSettingsIcon — 1.166.0 inline SVG used by both the main voice-settings
 * button (VoicePanel.tsx) and per-row settings shortcut in
 * VoiceAgentQuickSwitcher.tsx.
 *
 * Visual: filled speech bubble with bottom-left tail + 2 stroked sound-wave
 * arcs to the right. Lesson from 1.165.0's F.1 mouth iteration: filled
 * silhouettes carry more contrast than outlines at 16-20px. The bubble is
 * filled, the waves are stroked at strokeWidth=1.8 for legibility at small
 * sizes.
 *
 * Default className `w-6 h-6` (~20px at 13px root font) — caller can override.
 */
interface VoiceSettingsIconProps {
  className?: string;
}

export function VoiceSettingsIcon({ className = 'w-6 h-6' }: VoiceSettingsIconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      {/* speech bubble — filled, rounded corners, bottom-left tail */}
      <path
        d="M5 4 H15 A2 2 0 0 1 17 6 V12 A2 2 0 0 1 15 14 H10 L6 18 V14 H5 A2 2 0 0 1 3 12 V6 A2 2 0 0 1 5 4 Z"
        fill="currentColor"
      />
      {/* sound wave arcs — stroked, increasing radius outward to the right */}
      <path
        d="M19 7.5 a3.5 3.5 0 0 1 0 5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M21.5 5 a6.5 6.5 0 0 1 0 10"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
